<template>
  <div class="root">
    <main-button @click="$emit('onAdd')" class="upload-button">
      <img class="upload-icon" src="../files/upload-icon.svg" alt="upload icon" />
      Загрузить подложку
    </main-button>
    <main-text class="upload-text">или</main-text>
    <main-button @click="$emit('onMapUploadClick')" class="upload-map-button" color="link-secondary"
      >Использовать карту</main-button
    >
  </div>
</template>

<script>
import Text from "../components/ui/Text.vue";
import MainButton from "./ui/MainButton.vue";
export default {
  components: { MainButton, "main-text": Text },
};
</script>

<style scoped>
.root {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upload-icon {
  margin-right: 10px;
}
.upload-text {
  margin: 8px 0;
}
.upload-map-button {
  padding: 0;
  min-height: 16px;
}
</style>
